<template lang="pug">
  .container
    iframe(
      src="https://www.nerds.ai",
      width="100%",
      height="100%",
      frameborder="0"
    )
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    min-height: 0;
    border-top: 2px solid #0e5ccf;

    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>